export const PRODUCTION_LANE_REQUEST_STATES = [
  "idle",
  "loading",
  "loaded",
  "error",
];

export function createLaneRequestStateMap(lanes) {
  return lanes.reduce((state, laneKey) => {
    state[laneKey] = { status: "idle", error: null };
    return state;
  }, {});
}

export function getLaneTotal(json, laneKey) {
  return Number(
    json?.totalByLane?.[laneKey] ?? json?.total ?? (json?.data || []).length
  ) || 0;
}

export function getLanePagination({ page = 1, total = 0, pageSize, hasMore }) {
  const normalizedPage = Number(page) || 1;
  const normalizedTotal = Number(total) || 0;
  const normalizedPageSize = Number(pageSize) || 1;
  return {
    page: normalizedPage,
    total: normalizedTotal,
    hasMore: typeof hasMore === "boolean" ? hasMore : normalizedPage * normalizedPageSize < normalizedTotal,
    loading: false,
  };
}

/**
 * Starts every request immediately and reports each result independently.
 * A request that is no longer current is ignored, while another lane may
 * still succeed and update the board.
 */
export function runConcurrentLaneRequests({
  lanes,
  requestLane,
  isCurrent = () => true,
  onLaneSuccess,
  onLaneError,
}) {
  return Promise.all(
    lanes.map(async (laneKey) => {
      try {
        const result = await requestLane(laneKey);
        if (isCurrent(laneKey)) onLaneSuccess?.(laneKey, result);
        return { laneKey, status: "loaded", result };
      } catch (error) {
        if (isCurrent(laneKey)) onLaneError?.(laneKey, error);
        return { laneKey, status: "error", error };
      }
    })
  );
}

